import CryptoJS from "crypto-js";
import { ZIM } from "zego-zim-web";

// Ensure CryptoJS is properly loaded
if (typeof window !== 'undefined' && !window.CryptoJS) {
  window.CryptoJS = CryptoJS;
}

const appConfig = {
  appID: 846753220, // The AppID you get from the ZEGOCLOUD admin console.
  serverSecret: "27933668fde2ea2320b24c7663ac58cf", // ServerSecret - type: 32 byte length string
};

// Validate appConfig on module load
if (!appConfig.serverSecret || typeof appConfig.serverSecret !== 'string' || appConfig.serverSecret.length === 0) {
  console.error("Error: appConfig.serverSecret is not properly configured");
}

export const avatarPrefix = "https://storage.zego.im/zim/example/web/assets/";

ZIM.create(appConfig);
export const zim = ZIM.getInstance();
export const SDKVersion = ZIM.getVersion();

// @ts-ignore
window.zim = zim;

export function generateToken(userID: string, seconds: number): string {
  if (!userID) throw new Error("generateToken error: params invalid.");

  if (!appConfig.serverSecret || typeof appConfig.serverSecret !== 'string' || appConfig.serverSecret.length === 0) {
    throw new Error("generateToken error: serverSecret is not configured.");
  }

  if (!CryptoJS || !CryptoJS.enc || !CryptoJS.AES) {
    throw new Error("generateToken error: CryptoJS library is not properly loaded.");
  }

  try {
    const time = (Date.now() / 1000) | 0;
    const body = {
      app_id: Number(appConfig.appID),
      user_id: String(userID),
      nonce: (Math.random() * 2147483647) | 0,
      ctime: time,
      expire: time + Number(seconds || 7200),
    };

    const key = CryptoJS.enc.Utf8.parse(appConfig.serverSecret);
    let iv = Math.random().toString().substring(2, 18);
    if (iv.length < 16) iv += iv.substring(0, 16 - iv.length);

    const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(body), key, {
      iv: CryptoJS.enc.Utf8.parse(iv),
    }).toString();
    const ciphert = Uint8Array.from(
      Array.from(atob(ciphertext)).map((val) => val.charCodeAt(0))
    );
    const len_ciphert = ciphert.length;

    const uint8 = new Uint8Array(8 + 2 + 16 + 2 + len_ciphert);
    uint8.set([0, 0, 0, 0]);
    uint8.set(new Uint8Array(Int32Array.from([body.expire]).buffer).reverse(), 4);
    uint8[8] = iv.length >> 8;
    uint8[9] = iv.length - (uint8[8] << 8);
    uint8.set(
      Uint8Array.from(Array.from(iv).map((val) => val.charCodeAt(0))),
      10
    );
    uint8[26] = len_ciphert >> 8;
    uint8[27] = len_ciphert - (uint8[26] << 8);
    uint8.set(ciphert, 28);

    const token = `04${btoa(String.fromCharCode(...Array.from(uint8)))}`;
    localStorage.setItem("zego-token", token);
    localStorage.setItem("current-user-id", body.user_id);

    return token;
  } catch (error: any) {
    console.error("generateToken error:", error);
    const errorMessage = error?.message || (typeof error === 'string' ? error : JSON.stringify(error)) || 'Unknown error occurred during token generation';
    throw new Error(`generateToken error: ${errorMessage}`);
  }
}
